import React from "react";
import { Gavel } from "lucide-react";

// OmniAuc brand mark: electric-blue ring (the "O") enclosing a gold gavel (the "A").
export const LogoMark = ({ size = 36, className = "" }) => (
    <span
        className={`relative inline-flex shrink-0 items-center justify-center ${className}`}
        style={{ width: size, height: size }}
        aria-hidden
    >
        <span
            className="absolute inset-0 rounded-full"
            style={{ border: `${Math.max(2, size * 0.09)}px solid hsl(var(--brand-blue))` }}
        />
        <Gavel
            style={{ width: size * 0.5, height: size * 0.5, transform: "rotate(-12deg)" }}
            className="text-brass"
        />
    </span>
);

export const LogoLockup = ({ size = 36, withTagline = true, className = "" }) => (
    <span className={`flex items-center gap-2.5 ${className}`}>
        <LogoMark size={size} />
        <span className="flex flex-col leading-none">
            <span className="font-display text-lg font-extrabold tracking-tight">
                <span className="text-foreground">Omni</span>
                <span className="text-electric">Auc</span>
            </span>
            {withTagline && (
                <span className="mt-0.5 text-[9px] font-semibold uppercase tracking-[0.14em] text-brass">
                    The Fair Auction Marketplace™
                </span>
            )}
        </span>
    </span>
);
